import React from 'react';
import type { GlobalSearchHit } from '../types';
import FieldList from './FieldList';
import ViewDetailsLink from './ViewDetailsLink';

const ResultCard: React.FC<{ hit: GlobalSearchHit; onNavigated: () => void }> = ({ hit, onNavigated }) => (
  <div className="rounded-lg border border-border bg-card p-4 shadow-sm" data-testid={`global-search-card-${hit.id}`}>
    <div className="mb-2 flex justify-end">
      <ViewDetailsLink hit={hit} onNavigated={onNavigated} />
    </div>
    <FieldList hit={hit} />
  </div>
);

export default ResultCard;
